const HeaderBannerSkeleton = () => {
  return <div className='h-10 w-full animate-pulse bg-gray-100 lg:h-[60px]' data-sentry-component="HeaderBannerSkeleton" data-sentry-source-file="skeleton.tsx" />;
};
export default HeaderBannerSkeleton;